/** استخراج معرف فيديو يوتيوب من أي صيغة شائعة للرابط */
export function getYoutubeVideoId(url) {
  if (!url || typeof url !== "string") return "";

  const trimmed = url.trim();
  const patterns = [
    /(?:youtube\.com\/(?:embed\/|watch\?v=|watch\?.+&v=|shorts\/|live\/))([A-Za-z0-9_-]{11})/,
    /youtu\.be\/([A-Za-z0-9_-]{11})/,
    /^([A-Za-z0-9_-]{11})$/,
  ];

  for (const pattern of patterns) {
    const match = trimmed.match(pattern);
    if (match?.[1]) return match[1];
  }

  return "";
}

/** تحويل أي رابط يوتيوب إلى embed URL للـ iframe / YT.Player */
export function toYoutubeEmbedUrl(url) {
  const id = getYoutubeVideoId(url);
  return id ? `https://www.youtube.com/embed/${id}` : "";
}
